import { openBlock as e, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, n = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.333 9A8.333 8.333 0 1 1 .667 9a8.333 8.333 0 0 1 16.666 0M6.475 6.475a.625.625 0 0 1 .883 0L9 8.117l1.642-1.642a.625.625 0 0 1 .883.883L9.883 9l1.642 1.642a.625.625 0 0 1-.883.883L9 9.883l-1.642 1.642a.625.625 0 0 1-.883-.883L8.117 9 6.475 7.358a.625.625 0 0 1 0-.883",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function c(d, a) {
  return e(), l("svg", t, [...r]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
